import { IconDefinition } from "./types";

const bin: IconDefinition = {
  iconName: "bin",
  width: 576,
  height: 512,
  svgPathData:
    "M32 64l-32 0 0 48 33.5 0 30.5 336 448 0 30.5-336 33.5 0 0-48-544 0zm462.3 48l-26.2 288-360.3 0-26.2-288 412.7 0z",
  iconType: "fill",
  fill: "none",
  fontAwesomeName: "bin",
  unicode: 0xe763,
};

export { bin };
